<template>
  <div>
    <div class=""  v-if="!showStationList">
      <div v-show="bindingList.length>0">
        <div class="bg-white padding" style="position: relative; z-index: 2; padding-top: 24pt" ref="card">
          <div class="input-item" style="justify-content: space-between">
            <div style="display: flex">
              <div class="line"></div>
              <span class="text-nowrap">已綁有線電視繳費資訊</span>
            </div>
            <div style="float: right; font-size: 16px" class="text-blue" @click="changeModifyListStatus">{{ isListInModify ? '完成' : '編輯' }}</div>
          </div>
          <div class="dark-card">
            <div v-for="item in bindingList" :key="item.customer_number" class="flex">
              <div>
                <div class="main">{{item.station_name}}</div>
                <div class="info">戶號：{{item.customer_number}}</div>
                <div class="info">電話號碼：{{item.customer_phone_number}}</div>
              </div>
              <div class="delete" @click="unbind(item.bind_serial_number)" v-if="isListInModify"></div>
              <div class="active" @click="getBill(item.station_number, item.customer_number, item.customer_phone_number)" v-else>查詢</div>
            </div>
          </div>
        </div>
        <div class="bind-other-link" @click="bindOther()">綁定其他戶號</div>
      </div>
      <div class="padding bg-white" v-show="bindingList.length===0">
        <div>
          <div class="input-item text-nowrap">
            <div class="line"></div>
            <span class="text-nowrap">請輸入有線電視繳費資訊</span>
          </div>
          <div class="input-item-more"><span class="required">*</span>戶號</div>
          <input type="text" name="customerNumber" placeholder="請輸入戶號 (最多 10 碼)" class="input" v-model="customerNumber" />
          <div class="border-bottom" :style="borderStyle"></div>
          <div class="input-item-more"><span class="required">*</span>電話號碼</div>
          <input type="text" name="customerPhoneNumber" placeholder="請輸入手機號碼或市話（不含區碼）" class="input" v-model="customerPhoneNumber"  />
          <div class="border-bottom" :style="borderStyle"></div>          
          <button class="btn btn-primary" :disabled="isDisabled" @click="bindBillInformation">綁定繳費資訊</button>
        </div>
      </div>
      <div class="padding description">
        <ul class="text-gray2">
          <li>綁定後，新帳單將<span class="text-blue">自動通知</span>。</li>
          <li>台固媒體股份有限公司，僅提供網路費用繳費服務。</li>
          <li>可使用悠遊付錢包、銀行帳戶連結進行繳費扣款。</li>
          <li>繳費後無法取消，若需退費請洽<a @click="openCableFeeVendorServiceUrl()" class="text-blue">各業者客服中心。</a></li>
          <li>綁定後，下期帳單將透過APP通知繳費(請留意推播或首頁左上角小鈴鐺)，不再寄送紙本或簡訊帳單。</li>
        </ul>
      </div>
      <div :class="isListInModify ? 'mask' : ''" ref="mask"></div>
    </div>

    <div style="background-color: white" v-if="showStationList">
    <div class="search-bar">
          <img src="../../assets/images/tuitionFee/barsSearchBarResourcesSearchGlyph.png" style="width: 14px; height: 14px; margin-right: 8px;">
          <input placeholder="請輸入有線電視公司名稱" v-model="stationModal.filterKeyword" @input="filter()" />
          <img src="../../assets/images/tuitionFee/clear.png" style="width: 14px; height: 14px; " v-show="stationModal.filterKeyword !== ''" @click="clearFilter()">
      </div>
      
      <div>
        <div @click="stationClicked(station)" v-for="(station, i) in stationModal.filteredStations" :key="i">
            <div class="block">
              <div class="item">
                <div class="text-gray2">{{ station.station_name }}</div>
                <div class="arrow"><img src="@/assets/images/iconArrowSign.png" width="24pt"></div>
              </div>            
              <div class="line" />
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getTvFeeStations, bindKbroBillInformation, getTvFeeBindingList, unbindKbroBillInformation, queryBillList } from '../../api/api';
import { mapActions } from 'vuex';

export default {
  name: 'kbro-fee',
  components: {
  },
  data() {
    return {
      stop: 0,
      stationModal: {
        filterKeyword: '',
        show: true,
        supportStations: [],
        filteredStations: [],      
      },
      stationNumber: '',
      stationName: '',
      bindingList: [],
      isListInModify: false,
      isAddFavoriteChecked: true,    
      customerPhoneNumber: '',
      customerNumber: '',
    };
  },
  mounted() {
    this.getTvFeeBindingList();
    this.showStataions();
  },
  computed: {
    showStationList() {
      return this.stationNumber==='' && this.bindingList.length===0;
    },
    isDisabled() {
      if (this.customerNumber == undefined || this.customerPhoneNumber === undefined) {
        return true;
      }
      
      //let result = !(this.customerNumber.match(/[0-9]{1,}/) && this.customerPhoneNumber.match(/[0-9\-\(\)]{1,}/));
      //alert(result);
      //return result;
      return false;
    },
    borderStyle() {
      return 'background: #c7c7c7';
    },
    search_btn_disable() {
      return !Object.values(this.verifyInputRule).every((i) => i === true);
    },
  },
  methods: {
    ...mapActions(['setReadyToPayBill', 'sentApp']),
    bindOther() {
      this.bindingList = [];
    },
    openCableFeeVendorServiceUrl() {
      this.sentApp({
        action: 'openExternalBrowser',
        payload: { url: 'https://ephttp.easycard.com.tw/app_html/cableOperator_20220803.pdf' },
      });
    },
    getTvFeeBindingList() {    
      getTvFeeBindingList().then((res) => {
        if (res.error === undefined) {
          this.bindingList = res.binding_list;
          
          setTimeout(() => {
            var height = this.$refs.card.clientHeight;
            this.$refs.mask.style.top = height + 'px';
          }, 1000);
        }
      });
    },
    bindBillInformation() {
      if (this.isAddFavoriteChecked) {
        bindKbroBillInformation({ station_number: this.stationNumber, customer_number: this.customerNumber, customer_phone_number: this.customerPhoneNumber }).then((res) => {
          if (res.error != null) {
            alert(res.error.message);
          } else {
            this.getTvFeeBindingList();
            this.getBillIsNull();
          }
        });
      } else {
        this.getBillIsNull();
      }
    },
    searchBill(form) {
      this.$router.push({
        path: '/goPay',
        query: form,
      });
    },
    getBill(stationNumber, customerNumber, customerPhoneNumber) {
      this.stationNumber = stationNumber;
      this.customerNumber = customerNumber;
      this.customerPhoneNumber = customerPhoneNumber;
      this.getBillIsNull();
    },
    getBillIsNull() {
      var form = {
        payment_item_id: 'KBRO',
        payment_query_type: 1,
        parameter1: this.stationNumber,
        parameter2: this.customerNumber,
        parameter3: this.customerPhoneNumber,
        payment_custom_id: '',
      };
      queryBillList(form).then((res) => {
        if (res.error == null) {
          this.setReadyToPayBill(res);
          this.searchBill(form);
        } else {
          alert(res.error.message);
        }
      });
    },
    changeModifyListStatus() {
      this.isListInModify = !this.isListInModify;
    },
    unbind(serialNumber) {
      if (confirm('確定要刪除？')) {
        unbindKbroBillInformation({ serial_number: serialNumber }).then((res) => {
          if (res.error == null) {
            this.isListInModify = false;
            this.getTvFeeBindingList();
          } else {
            alert(res.error.message);
          }
        });
      }
    },
    clearFilter() {
      this.stationModal.filterKeyword = '';
      this.filter();
    },
    filter() {
      if (this.stationModal.filterKeyword === '') {
        this.generateFilterStations(this.stationModal.supportStations);
      } else {
        var list = [];
        this.stationModal.supportStations.forEach((item, i) => {
          if (item.station_name.indexOf(this.stationModal.filterKeyword) !== -1) {
            list.push(item);
          }
        });
        this.generateFilterStations(list);
      }
    },
    generateFilterStations(list) {
      this.stationModal.filteredStations = [];
      list.forEach((item, i) => {
        this.stationModal.filteredStations.push(item);
      });
    },
    stationClicked(station) {
      this.stationNumber = station.station_number;
      this.stationName = station.station_name;      
      this.$store.dispatch('sentApp', {
        action: 'configureAppWebPage',
        payload: { title: this.stationName, headerType: 'white' },
      });
    },
    closeStations() {
      this.stationModal.show = false;
    },
    showStataions() {
      getTvFeeStations().then((res) => {
        if (res.error === undefined) {
          this.stationModal.supportStations = res.station_list;
          this.filter();
          this.stationModal.show = true;
        }
      });
    },
  },
};
</script>
<style type="text/scss" lang="scss" scoped>
.arrow {
  width: 24px;
  height: 24px;
  display: flex;  
}

.required {
  margin-top: 2pt;
  margin-bottom: 26pt;
  font-size: 12pt;
}

.hint {
  display: flex;
  flex-flow: row;
  align-items: center;
  margin: 18px auto 0px auto;
  justify-content: center;
}

.hint span {
  color: rgba(64, 64, 64, 0.6);
  font-size: 14px;
  text-align: center;  
  line-height: 24px;
}



.item {
  min-height: 56px;
  padding-left: 20px;
  padding-right: 20px;
  background: white;  
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.item .line {
  background-color: rgba(64, 64, 64, 0.1);
  width: 80%;
  height: 1px;
  margin-left: 20px;
}

.item-title {
  margin: 8px 20px;  
  font-size: 14px;
  flex-grow: 1;
}

.item .text-gray2 {  
  line-height: 55px;
}

.search-bar {
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  vertical-align: middle;
  position: relative;
  height:36px;
  margin: 8px 20px 15px 20px;
  background: rgba(142, 142, 147, 0.12);
  padding: 6px 12px;
  align-items: center;
  justify-content: center;
}
 
.empty {
  color: rgba(64, 64, 64, 0.4);
  font-size: 16px;
  margin: 24px auto;
  text-align: center;
}
 
.search-bar input {
  background: transparent;
  border-style: none;
  height: 36px;
  flex-grow: 1;
}

.input-item-more {
  margin-top: 24px;
}

.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9pt 0;
  border-bottom: 1px solid rgba(64, 64, 64, 0.75);
}

.dark-card .info {
  color: #c7c7c7;
  font-size: 12px;
  margin-bottom: 4px;
}

.dark-card .main {
  font-size: 16px;
  margin-bottom: 4px;
}

.bind-other-link {
  font-size: 14px;
  color: rgba(64, 64, 64, 0.75);
  margin: 32px auto 36px auto;
  text-align: center;
  text-decoration: underline;
}
</style>
